import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import {ArrowLeft, ArrowRight} from "@mui/icons-material";
import {Grid, Paper, Radio, Stack, Typography} from "@mui/material";
import { styled } from '@mui/material/styles';
import t from "../../../Utils/Translation";
import candidates from "./Candidates";
import {Container, Row, Col, Ratio, Image} from 'react-bootstrap';
import Button from "@mui/material/Button";
import LykioButton from "../../common/LykioButton";
import { useNavigate } from 'react-router-dom';

const LykioCustomButton = styled(Button)(() => ({
    background: "linear-gradient(to bottom, #006f4b, #006f4b)",
    color: "white",
    borderColor: "#c4c5c7",
    '&:hover': {
        background: "white",
        color: "#006f4b",
        borderStyle: 'solid !important',
        borderWidth: '0.2em',
        borderRadius: '7px',
        borderColor: "#006f4b"
    },
}));

const useStyles = makeStyles(theme => ({
    sliderContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflowX: 'scroll',
        scrollbarWidth: 'none', /* Hide scrollbar in Firefox */
        '-ms-overflow-style': 'none', /* Hide scrollbar in Internet Explorer */
        '&::-webkit-scrollbar': {
            display: 'none', /* Hide scrollbar in Chrome and Safari */
        },
        width: '100%', // set container width to 100%
    },
    slide: {
        width: '85%',
        margin: theme.spacing(2),
        padding: theme.spacing(4),
        border: `1px solid #006f4b`,
        borderRadius: 50,
        backgroundColor: '#006f4b',
        boxShadow: theme.shadows[1],
    },

    arrowButton: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[1],
        '&:hover': {
            color: theme.palette.text.primary,
        },
    },
    leftArrowButton: {
        left: theme.spacing(1),
    },
    rightArrowButton: {
        right: theme.spacing(1),
    },
}));




const ResultChoices = ({candidatesResults,setIsBackClicked, setCurrentStep }) => {
    const classes = useStyles();
    const [slideIndex, setSlideIndex] = useState(0);

    const handlePrevClick = () => {
        setSlideIndex(prevIndex => (prevIndex > 0 ? prevIndex - 1 : items.length - 1));
    };

    const handleNextClick = () => {
        setSlideIndex(prevIndex => (prevIndex < items.length - 1 ? prevIndex + 1 : 0));
    };

    const navigate = useNavigate();

    const handleButtonClick = () => {
      navigate('/');
    };

    const handleBackClick = () => {
        setCurrentStep(3)
        setIsBackClicked(true)
    }

    const items = [
        {
            id: 'candidate1',
            title: 'Silvia',
            image: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/SILVIA.jpeg',
            selectedChoiceOption1: candidatesResults.candidate1.option1,
            selectedChoiceOption2: candidatesResults.candidate1.option2,
            affidabilitaTrue: candidatesResults.candidate1.option1 === candidatesResults.candidate1.option1correct,
            affidabilitaTrueText: t("Your assessment is correct: despite her presentation and CV presenting a work background rich in experiences, having changed many workplaces in a short time may indicate a person who is unreliable and inclined to chasing the best job opportunity as soon as it presents itselft."),
            affidabilitaFalseText: t('What led you to see Silvia as reliable? Is it possible that her well-groomed appearance, her confident tone, and her many experiences, by the halo effect, influenced your assessment? Actually, by going deeper into the profile, it can be seen that Silvia, driven by her personal ambition, quickly leaves jobs without worrying about the fact that her action could cause problems.'),
            teamworkCrossTrue: candidatesResults.candidate1.option2 === candidatesResults.candidate1.option2correct,
            teamworkCrossTrueText: t("Your assessment is correct. From her presentation it is possible to deduce how Silvia did have an experience with a multicultural team, but with poor results, attributed by her to the colleagues who were in her team"),
            teamworkCrossFalseText: t("What factors led you to believe that Silvia is a particularly suitable candidate for collaborations with a multicultural team? Rethink her presentation: she does not show to have appreciated teamworking, nor confronting with cultures different from hers"),

        },
        {
            id: 'candidate2',
            title: 'Bilal',
            image: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/BILAL.png',
            selectedChoiceOption1: candidatesResults.candidate2.option1,
            selectedChoiceOption2: candidatesResults.candidate2.option2,
            affidabilitaTrue: candidatesResults.candidate2.option1 === candidatesResults.candidate2.option1correct,
            affidabilitaTrueText: t('Great job! By listening to his presentation and consulting his CV, you recognized in Bilal a reliable resource. The candidate presented himself as a focused and dedicated worker, consistent and reliable. These qualities are also reflected in his passion for physical activity and competitive sport.'),
            affidabilitaFalseText: t('You believed that Bilal was not a reliable candidate. Do you think some factors influenced your evaluation? Try listening to his presentation again: Bilal introduced himself as a diligent and hardworking resource, qualities that are confirmed by his work experience, which began concurrently with his university studies.'),
            teamworkCrossTrue: candidatesResults.candidate2.option2 === candidatesResults.candidate2.option2correct,
            teamworkCrossTrueText: t('Your assessment is correct: Bilal appears to be very closed off to the possibility of moving outside his own area and more oriented towards working solo than working in a team.'),
            teamworkCrossFalseText: t("What factors led you to believe that Bilal was oriented towards Cross-cultural Teamwork? Try to rethink your choice: to what extent did Bilal's physical appearance and his origin from an Arab family play a role in your evaluation? The \"Halo effect\" occurs when our decisions are influenced by a person's appearance: the fact that someone is of foreign origin doesn't automatically mean they are open to multiculturalism. Actually, Bilal appears to be very closed off to the possibility of moving outside his own area and more oriented towards working solo that working in a team."),
        },
        {
            id: 'candidate3',
            title: 'Giulia',
            image: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/valutazione1/GIULIA_.png',
            selectedChoiceOption1: candidatesResults.candidate3.option1,
            selectedChoiceOption2: candidatesResults.candidate3.option2,
            affidabilitaTrue: candidatesResults.candidate3.option1 === candidatesResults.candidate3.option1correct,
            affidabilitaTrueText: t("Your assessment is correct: you have recognized Giulia as a reliable resource. A careful analysis of the candidate's presentation and CV reveals the profile of a reliable person, respectful of her commitments and coworkers, also available to dedicate time and resources to enable the team to achieve its objectives."),
            affidabilitaFalseText: t("What factors led you to evaluate Giulia as an unreliable candidate? Rethink her presentation and determine whether your choice has been influenced by a bias: is it because she is a young mother? Or is it the image of a slightly messy home in the background of the call that gave you this idea? If you listen carefully, the profile of reliable person emerges, respectful of her commitments and of people, even willing to dedicate extra time and resources to allow the team to achieve its objectives."),
            teamworkCrossTrue: candidatesResults.candidate3.option2 === candidatesResults.candidate3.option2correct,
            teamworkCrossTrueText: t('Great job! You have recognized in Giulia a good predisposition for teamwork and an openness to interculturality that emerged strongly from her previous experiences in Italy and abroad. Have you notice how she appreciates working with colleagues and acquiring new experiences?'),
            teamworkCrossFalseText: t('What factors led you to believe that Giulia is not oriented towards Cross-Cultural Teamwork? Rethink your choice: Giulia has a history of successful teamwork experiences and shows great openness. Is it possibile that the fact that the candidate is a mother of a small child may have influenced your evaluation? The fact of being a young mother is not necessarily an obstacle to her possibility of relocating, travelling and working in intercultural teams'),
        },
    ];
    console.log(items);

    return (
        <Box position="relative">
            <IconButton
                className={`${classes.arrowButton} ${classes.leftArrowButton}`}
                onClick={handlePrevClick}
                aria-label="Previous"
            >
                <ArrowLeft />
            </IconButton>
            <Box className={classes.sliderContainer}>
                {items.map((item, index) => (
                    <Box key={item.id} className={classes.slide} style={{ display: slideIndex === index ? 'block' : 'none' }}>
                        <Typography style={{color:'white'}} variant={'h2'}>{item.title}</Typography>
                       <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <div className={'d-flex align-items-center justify-content-center w-100 h-100 overflow-hidden'}>
                                <Ratio aspectRatio="1x1">
                                    <Image src={item.image}/>
                                </Ratio>
                                    {/* <img src={item.image} alt={'s'} style={{objectFit: 'cover', width: '100%', height: '100%'}}/> */}
                                </div>

                            </Grid>

                           <Grid item xs={8}>
                               <Grid container spacing={3}>
                                   <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                       
                                   <Container>
                                            <Row>
                                                <Col xs={1} style={{marginTop:'1em'}}>
                                                    <Radio
                                                        checked={item.selectedChoiceOption1}
                                                        sx={{
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: 28,
                                                                color: 'white',
                                                            }
                                                        }}

                                                    />
                                                </Col>
                                                
                                                <Col xs={5}>
                                                <Box sx={{borderRadius: 8, p:2, backgroundColor: '#098b43', marginLeft: 5}}>
                                                        <p className="valBoxSize">
                                                            {t('RELIABILITY')}
                                                        </p>
                                                    </Box>
                                                </Col>

                                                <Col xs={6}>
                                                <Typography sx={{color: 'white'}}>
                                                   {item.affidabilitaTrue ? item.affidabilitaTrueText : item.affidabilitaFalseText}
                                               </Typography>
                                                </Col>
                                            </Row>
                                       </Container>
                                       
                                       {/* <Grid container alignItems={'center'} spacing={4}>
                                            <Grid item xs={4}>
                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                    <Radio
                                                        checked={item.selectedChoiceOption1}
                                                        sx={{
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: 28,
                                                                color: 'white',
                                                            }
                                                        }}

                                                    />
                                                    <Box sx={{borderRadius: 8, p:2, backgroundColor: '#098b43', marginLeft: 5}}>
                                                        <p className="valBoxSize">
                                                            {t('AFFIDABILITÀ')}
                                                        </Typography>
                                                    </Box>


                                                </div>

                                            </Grid>
                                           <Grid item xs>
                                               <Typography sx={{color: 'white'}}>
                                                   {item.affidabilitaTrue ? item.affidabilitaTrueText : item.affidabilitaFalseText}
                                               </Typography>
                                           </Grid>
                                       </Grid> */}

                                   </Grid>
                                   <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                       <Container>
                                            <Row>
                                                <Col xs={1} style={{marginTop:'2em'}}>
                                                    <Radio
                                                        checked={item.selectedChoiceOption2}
                                                        sx={{
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: 28,
                                                                color: 'white',
                                                            }
                                                        }}

                                                    />
                                                </Col>
                                                
                                                <Col xs={5}>
                                                <Box sx={{borderRadius: 8, p:2, backgroundColor: '#098b43', marginLeft: 5}}>
                                                       <p className="valBoxSize">
                                                           {t('CROSSCULTURAL TEAMWORK')}
                                                       </p>
                                                   </Box>
                                                </Col>

                                                <Col xs={6}>
                                                <Typography sx={{color: 'white'}}>
                                                   {item.teamworkCrossTrue ? item.teamworkCrossTrueText : item.teamworkCrossFalseText}
                                               </Typography>
                                                </Col>
                                            </Row>
                                       </Container>

                                       {/* <Grid container alignItems={'center'} spacing={4}>
                                           <Grid item xs={4}>
                                               <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                   <Radio
                                                       checked={item.selectedChoiceOption2}
                                                       sx={{
                                                           '& .MuiSvgIcon-root': {
                                                               fontSize: 28,
                                                               color: 'white',
                                                           }
                                                       }}

                                                   />
                                                   <Box sx={{borderRadius: 8, p:2, backgroundColor: '#098b43', marginLeft: 5}}>
                                                       <p className="valBoxSize">
                                                           {t('CROSSCULTURAL TEAMWORK')}
                                                       </Typography>
                                                   </Box>


                                               </div>

                                           </Grid>
                                           <Grid item xs>
                                               <Typography sx={{color: 'white'}}>
                                                   {item.teamworkCrossTrue ? item.teamworkCrossTrueText : item.teamworkCrossFalseText}
                                               </Typography>
                                           </Grid>
                                       </Grid> */}

                                   </Grid>


                               </Grid>









                           </Grid>
                       </Grid>
                    </Box>
                ))}
            </Box>
            <IconButton
                className={`${classes.arrowButton} ${classes.rightArrowButton}`}
                onClick={handleNextClick}
                aria-label="Next"
            >
                <ArrowRight />
            </IconButton>

            <div className="lykiocss-center">{t("Use the right and left arrows to view the summary sheets of the three candidates.")}</div>
            <div className="lykiocss-center" style={{gap: '20px'}}>
                <LykioCustomButton onClick={handleBackClick}
                                   style={{maxWidth:'20em', fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em', marginBottom:'2em'}} className="lykiocss-margin-top-1em" >
                    {t('PRESENTATIONS')}
                </LykioCustomButton>
                <LykioCustomButton onClick={handleButtonClick} 
                    style={{maxWidth:'20em', fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em', marginBottom:'2em'}} className="lykiocss-margin-top-1em" >
                        {t('END')}
                </LykioCustomButton>
            </div>

        </Box>
    );
};

export default ResultChoices;